// if this value changes, tailwind.config.js safelist must be updated
export const DETAILS_TRANSITION_DURATION = 700
